import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/HBA_Logo_1x.png")